import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tooltip-popover',
  templateUrl: './tooltip-popover.component.html',
  styleUrls: ['./tooltip-popover.component.scss'],
  imports: [TranslatePipe],
})
export class TooltipPopoverComponent {
  @Input() text: string = '';

  constructor() {}
}
